export enum AddOnProduct {
    None = 0,
    SmsCredits500 = 1,
}